var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unit-card-feature-list"},[_c('ul',{staticClass:"unit-card-feature-list__list"},_vm._l((_vm.features),function(feature){return _c('li',{key:feature.id,staticClass:"unit-card-feature-list__list-item"},[_c('span',[_vm._v(_vm._s(feature.longText))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }